import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';
import { Typography } from '@mui/material';
import Container from 'components/Container';
import { Sidebar2023 } from 'views/SchoolProgram2023/components';
import Sidebar2024 from '../SchoolProgram2023/components/Sidebar2024';
import Archive2022 from '../SchoolProgram2023/components/Archive2022';
import { Sidebar2025 } from '../SchoolProgram2023/components';

const MathFair2025 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });
    const [config, setConfig] = useState({ base_image_url_2025: '' });
    useEffect(() => {
      fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
        .then(response => response.json())
        .then(data => setConfig(data))
        .catch(error => console.error('Error fetching config:', error));
    }, []);
    
    const p1 = `${config.base_image_url_2025}/home/events-activities/school-programs/MathFair/1.webp`;
    const p2 = `${config.base_image_url_2025}/home/events-activities/school-programs/MathFair/2.webp`;
    const p3 = `${config.base_image_url_2025}/home/events-activities/school-programs/MathFair/3.webp`;
    const p4 = `${config.base_image_url_2025}/home/events-activities/school-programs/MathFair/4.webp`;
    const p5 = `${config.base_image_url_2025}/home/events-activities/school-programs/MathFair/5.webp`;
    const p6 = `${config.base_image_url_2025}/home/events-activities/school-programs/MathFair/6.webp`;
    const p7 = `${config.base_image_url_2025}/home/events-activities/school-programs/MathFair/7.webp`;
    const p8 = `${config.base_image_url_2025}/home/events-activities/school-programs/MathFair/8.webp`;
    const p9 = `${config.base_image_url_2025}/home/events-activities/school-programs/MathFair/9.webp`;
     

1
   
const photos = [
  {
  src: p1,
  source: p1,
  rows: 1,
  cols: 1,
},
{
  src: p2,
  source: p2,
  rows: 1,
  cols: 1,
},
{
  src: p3,
  source: p3,
  rows: 1,
  cols: 1,
},
{
  src: p4,
  source: p4,
  rows: 1,
  cols: 1,
},
{
  src: p5,
  source: p5,
  rows: 1,
  cols: 1,
},
{
  src: p6,
  source: p6,
  rows: 1,
  cols: 1,
},
{
  src: p7,
  source: p7,
  rows: 1,
  cols: 1,
},
{
  src: p8,
  source: p8,
  rows: 1,
  cols: 1,
},
{
  src: p9,
  source: p9,
  rows: 1,
  cols: 1,
}     
    ];

    return (
        <Main>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box >
                                <Typography variant='h5' align='center'>
                              MATH FAIR 
                                </Typography>
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                              Date: 04 February 2026
                                </Typography>
                                {/* <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “If you believe in yourself and have dedication and determination and never quit, you'll be a winner. The price of victory is high but so are the rewards.”

                                <br />
                            </Typography> */}

                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
                                The students of Classes 4 and 5 embarked on a remarkable learning journey through the Mathematics Fair, ‘Ganit Yatra: A Cognitive Voyage,’ held on Wednesday, 4 February 2026. More than an event, it was an experience that transformed Mathematics from textbook concepts into a living, breathing journey of discovery, decision-making and exploration.
                                <br></br>
                                Ganit Yatra was designed as a mathematical journey that blended play with purposeful learning. Through engaging activities, students explored strategic thinking, logical reasoning, and decision-making while working towards shared goals. The experience then expanded into a broader exploration where students applied their understanding in new contexts, encouraging practical thinking, adaptability, and real-world connections, through the concept of world traveling.
                                <br></br>
                                The journey continued as students explored the culture of their assigned countries through engaging, hands on activities, connecting Mathematics to real world traditions and brought life to Mathematical Concepts through visual reasoning and perception. A creative giveaway challenged them to recreate an Art Form using Pixel Art, beautifully blending Mathematics with creativity, culture and heritage.
                                                        <br></br>
                                Ganit Yatra proudly showcased that while countries, cultures and currencies may change, mathematical thinking remains constant and universal, thereby empowering students to think, decide and understand the world with confidence.
                             
                               <br></br>
                                </Typography>
                            </Box>
                            <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “Exploring the universality of Mathematics across cultures and currencies.”

                                <br />
                            </Typography>

                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 300 : 500}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                    <Box marginBottom={4}>
                            <Sidebar2025/>
                        </Box> 
                        <Box marginBottom={4}>
                            <Archive2022/>
                        </Box>

                    </Grid>
                </Grid>
            </Container>
        </Main>

    );
};

export default MathFair2025;